module.exports = __webpack_public_path__ + "img/qilin-stage2-sulking.b92e37a5.png";